export default __webpack_public_path__ + "static/hunni_video_1440_opt-60ecdeb9ccee4265f1626775289651b8.mp4";